<template>
  <div class="fc-pickup-or-delivery" v-if="isFirstItem">
    <div class="fc-pop-container">
      <div class="fc-title">Select one of the following</div>
      <div class="fc-note">Please note, order need to be made 2 hours in advanced. <br />
Call our store directly for order &lt;2 hours. </div>
      <div class="fc-content">
        <div v-bind:class="{ 'fc-pickup': true, 'fc-active': tabIndex == 1 }" @click="tabIndex = 1">
          <i class="icon-ico-pickup"></i>
          <div>
            <label>STORE PICKUP</label>
          </div>
        </div>
        <div v-bind:class="{ 'fc-delivery': true, 'fc-active': tabIndex == 2 }" @click="tabIndex = 2">
          <i class="icon-ico-delivery"></i>
          <div>
            <label>DELIVERY</label>
            <p>
              Minimum order $50<br />
              Order above $180 will get FREE delivery<br />
              Delivery timing 9.30am to 10pm daily
            </p>
          </div>
        </div>
        <div class="fc-content_section fc-content-pickup" v-if="tabIndex == 1">
          <div class="fc-pickup-list">
            <span>PICKUP OUTLET</span>
            <ul>
              <li v-for="outlet in preAdd.Outlets" @click="selectedOutletId = outlet.OutletId" v-bind:class="{ 'fc-active': selectedOutletId == outlet.OutletId }">
                <div v-html="outlet.Address"></div>
                <span v-html="outlet.OperatingHours"></span>
              </li>
            </ul>
          </div>
          <div class="fc-pickup-date">
            <div>
              <span>PICKUP DATE</span>
              <flat-pickr placeholder="DD/MM/YYYY" v-model="pickupDateDate" :config="{minDate: new Date(), dateFormat: 'Y-m-d', disableMobile: true}"></flat-pickr>
            </div>
            <div>
              <span>PICKUP TIME</span>
              <flat-pickr placeholder="HH:MM" v-model="pickupDateTime" :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" @on-open="dayCreate" step="60"></flat-pickr>
            </div>
            <div class="fc-control" v-if="tabIndex > 0">
              <a v-bind:disabled="!pickupEnable" 
                   @click="selectDeliver">CONTINUE</a>
            </div>
          </div>
          <div class="fc-error" v-if="hasPickupError">Sorry, we are unable to handle orders at the selected time. Please choose another timing.</div>
        </div>
        <div class="fc-content_section fc-content-deliver" v-if="tabIndex == 2">
          <div class="fc-deliver-address">
            <span>DELIVER TO:</span>
            <div>
              <label>POSTAL CODE</label>
              <input type="text" minlength="6" maxlength="6" @blur="selectOutlet" v-model="deliverAddress.postalCode" />
              <a>Singapore ONLY</a>
            </div>
            <div style="display: none;">
              <label>UNIT NO.</label>
              <input type="text" v-model="deliverAddress.unitNo" />
              <span>#</span>
            </div>
            <div style="display: none;">
              <label>ADDRESS</label>
              <input readonly="readonly" type="text" :value="address.ADDRESS" />
            </div>
          </div>
          <div class="fc-pickup-date">
            <div>
              <span>DELIVER DATE</span>
              <flat-pickr placeholder="DD/MM/YYYY" v-model="pickupDateDate" :config="{minDate: new Date(), dateFormat: 'Y-m-d', disableMobile: true}"></flat-pickr>
            </div>
            <div>
              <span>DELIVER TIME</span>
              <flat-pickr placeholder="HH:MM" v-model="pickupDateTime" :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" @on-open="dayCreate" step="60"></flat-pickr>
            </div>
            <div class="fc-control" v-if="tabIndex > 0">
              <a v-bind:disabled="!deliveryEnable"
                  @click="selectDeliver">CONTINUE</a>
            </div>
          </div>
          <div class="fc-error" v-if="hasError">Sorry, we are unable to handle orders at the selected time. Please choose another timing.</div>
          
        </div>
      </div>
      <div class="fc-close" @click="close"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import flatPickr from 'vue-flatpickr-component'
import $ from 'jquery'
// import $ from 'jquery'
export default {
  components: {
    flatPickr
  },
  data () {
    return {
      tabIndex: 0,
      selectedOutletId: 0,
      deliverAddress: {
        postalCode: '',
        unitNo: '',
        address: ''
      },
      hasPickupError: false,
      hasError: false,
      pickupDateDate: null,
      pickupDateTime: null
    }
  },
  methods: {
    dayCreate (dObj, dStr, fp, dayElem) {
      if (dStr === '') {
        const td = this.tabIndex === 1 ? this.pickupMinDate : this.deliveryMinDate
        const hour = td.getHours() < 10 ? ('0' + td.getHours()) : ('' + td.getHours())
        const minute = td.getMinutes() < 10 ? ('0' + td.getMinutes()) : ('' + td.getMinutes())
        this.pickupDateTime = hour + ':' + minute
        return false
      }
    },
    selectDeliver: function () {
      const time = (this.pickupDateTime === null || this.pickupDateTime === '') ? '12:00' : this.pickupDateTime
      const data = {
        DeliveryType: this.tabIndex - 1,
        PostalCode: this.deliverAddress.postalCode,
        DeliveryDateTime: this.pickupDateDate + ' ' + time + ':00',
        DeliveryAddress: this.address.ADDRESS,
        OutletId: this.selectedOutletId
      }
      this.$store.dispatch('cart/addNewCart', data)
        .then(() => {
          this.$store.dispatch('cart/noneFirstItem', false)
        })
    },
    getAddress: function () {
      this.$store.dispatch('address/getAddress', this.deliverAddress.postalCode)
    },
    selectOutlet () {
      const pc = this.deliverAddress.postalCode
      if (pc === '' || pc.length !== 6 || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Invalid postal code',
            type: 'red',
            useBootstrap: false
          })
        }
        return
      }
      const preCode = pc.toString().substring(0, 2)
      if (this.preAdd.NoDeliveryLocations != null && this.preAdd.NoDeliveryLocations.indexOf(preCode) >= 0) {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'Sorry, this postal code is not in our delivery locations',
            type: 'red',
            useBootstrap: false
          })
        }
        return
      }
      const o = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
      if (o.length > 0) {
        this.selectedOutletId = o[0].OutletId
      } else {
        if (process.browser) {
          $.alert({
            title: 'Notice',
            content: 'There is no outlet for your postal code',
            type: 'red',
            useBootstrap: false
          })
        }
      }
    },
    close: function () {
      this.$store.dispatch('cart/noneFirstItem', false)
    },
    getEndDate (d, o) {
      if (d.getDay() === 0) {
        return o.OperatingHoursSunEnd
      } else if (d.getDay() === 1) {
        return o.OperatingHoursMonEnd
      } else if (d.getDay() === 2) {
        return o.OperatingHoursTuesEnd
      } else if (d.getDay() === 3) {
        return o.OperatingHoursWedEnd
      } else if (d.getDay() === 4) {
        return o.OperatingHoursThurEnd
      } else if (d.getDay() === 5) {
        return o.OperatingHoursFriEnd
      } else if (d.getDay() === 6) {
        return o.OperatingHoursSatEnd
      } else {
        return '12'
      }
    },
    getFromDate (d, o) {
      if (d.getDay() === 0) {
        return o.OperatingHoursSunFrom
      } else if (d.getDay() === 1) {
        return o.OperatingHoursMonFrom
      } else if (d.getDay() === 2) {
        return o.OperatingHoursTuesFrom
      } else if (d.getDay() === 3) {
        return o.OperatingHoursWedFrom
      } else if (d.getDay() === 4) {
        return o.OperatingHoursThurFrom
      } else if (d.getDay() === 5) {
        return o.OperatingHoursFriFrom
      } else if (d.getDay() === 6) {
        return o.OperatingHoursSatFrom
      } else {
        return '12'
      }
    },
    getPickupDate () {
      const today = new Date()
      const hour = today.getHours() < 10 ? ('0' + today.getHours()) : ('' + today.getHours())
      const minute = today.getMinutes() < 10 ? ('0' + today.getMinutes()) : ('' + today.getMinutes())
      const ds = (this.pickupDateFormat + ' ' + hour + ':' + minute + ':00').replace(/-/g, '/')
      return new Date(ds)
    },
    getPickupDateMonth () {
      const today = this.getPickupDate()
      return today.getMonth() < 10 ? ('0' + (today.getMonth() + 1).toString()) : (today.getMonth() + 1).toString()
    },
    getCurrentDateWithoutSec () {
      const today = new Date()
      const hour = today.getHours() < 10 ? ('0' + today.getHours()) : ('' + today.getHours())
      const minute = today.getMinutes() < 10 ? ('0' + today.getMinutes()) : ('' + today.getMinutes())
      const month = today.getMonth() < 10 ? ('0' + (today.getMonth() + 1).toString()) : (today.getMonth() + 1).toString()
      const mindate = new Date((today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':' + minute + ':00'))
      return mindate
    }
  },
  computed: {
    ...mapFields('cart', [
      'items', 'preAdd'
    ]),
    ...mapGetters('address', ['address']),
    ...mapGetters('cart', ['isFirstItem']),
    pickupEnable () {
      if (this.tabIndex === 1 && this.selectedOutletId > 0 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        const pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime()
        if (this.pickupMinDate === null || this.pickupMaxDate === null) {
          return false
        }
        const canPickup = pickupDate >= (this.pickupMinDate.getTime() - 60 * 1000) && pickupDate <= this.pickupMaxDate.getTime()
        if (canPickup) {
          this.hasPickupError = false
          return true
        } else {
          this.hasPickupError = true
          return false
        }
      }
      return false
    },
    pickupMinDate () {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date()
      }

      const o = this.preAdd.Outlets.filter(a => this.selectedOutletId === a.OutletId)
      if (o.length > 0) {
        const selectedPickupDate = new Date(this.pickupDateFormat + ' 00:00:00')
        const mindate = new Date((new Date()).getTime() + this.preAdd.SelfPickupMins * 1000 * 60)
        var hour = this.getFromDate(selectedPickupDate, o[0])
        if (hour === null) {
          return null
        }
        const endTime = new Date((new Date(this.pickupDateFormat + ' ' + hour + ':00')).getTime() + (2 * 60 * 60 * 1000))
        return endTime.getTime() > mindate.getTime() ? endTime : mindate
      }
      return new Date()
    },
    pickupMaxDate () {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date()
      }
      const o = this.preAdd.Outlets.filter(a => this.selectedOutletId === a.OutletId)
      if (o.length > 0) {
        const today = new Date(this.pickupDateFormat + ' 00:00:00')
        var hour = this.getEndDate(today, o[0])
        if (hour === null) {
          return null
        }
        const endTime = this.pickupDateFormat + ' ' + hour + ':00'
        return new Date(endTime)
      }
      return new Date()
    },
    deliveryEnable () {
      if (this.tabIndex === 2 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.deliverAddress.postalCode !== '' && this.deliverAddress.postalCode.length === 6 && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        const pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime()
        const canDelivery = pickupDate >= (this.deliveryMinDate.getTime() - 60 * 1000) && pickupDate <= this.deliveryMaxDate.getTime()
        if (this.deliveryMinDate !== null && this.deliveryMaxDate !== null && canDelivery) {
          this.hasError = false
          return true
        } else {
          return this.deliveryEnableReplace
        }
      }
      return false
    },
    deliveryEnableReplace () {
      if (this.tabIndex === 2 && this.pickupDateFormat !== null && this.pickupDateFormat !== '' && this.deliverAddress.postalCode !== '' && this.deliverAddress.postalCode.length === 6 && this.pickupDateTime !== null && this.pickupDateTime !== '') {
        const pickupDate = new Date(this.pickupDateFormat + ' ' + this.pickupDateTime + ':00').getTime()
        if (this.deliveryMinDateReplace === null || this.deliveryMaxDateReplace === null) {
          return false
        }
        const canDelivery = pickupDate >= this.deliveryMinDateReplace.getTime() && pickupDate <= this.deliveryMaxDateReplace.getTime()
        if (canDelivery) {
          this.hasError = false
          return true
        } else {
          this.hasError = true
          return false
        }
      }
      return false
    },
    deliveryMinDate () {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date()
      }
      const today = new Date(this.pickupDateFormat + ' 00:00:00') // this.getPickupDate()
      // const mindate = new Date(this.getCurrentDateWithoutSec().getTime() + this.preAdd.DeliveryMins * 1000 * 60)
      const mindate = new Date((new Date()).getTime() + this.preAdd.DeliveryMins * 1000 * 60)

      const pc = this.deliverAddress.postalCode
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return mindate
      }
      const preCode = pc.toString().substring(0, 2)
      const o = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
      if (o.length > 0) {
        this.selectedOutletId = o[0].OutletId
        // const month = this.getPickupDateMonth()
        var hour = this.getFromDate(today, o[0])
        if (hour === null) {
          return null
        }
        const endTime = new Date((new Date(this.pickupDateFormat + ' ' + hour + ':00')).getTime() + (2 * 60 * 60 * 1000))
        return endTime.getTime() > mindate.getTime() ? endTime : mindate
      }
      return mindate
    },
    deliveryMinDateReplace: {
      get: function () {
        if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
          return new Date()
        }
        const today = new Date(this.pickupDateFormat + ' 00:00:00') // this.getPickupDate()
        // const mindate = new Date(this.getCurrentDateWithoutSec().getTime() + this.preAdd.DeliveryMins * 1000 * 60)
        const mindate = new Date((new Date()).getTime() + this.preAdd.DeliveryMins * 1000 * 60)

        const pc = this.deliverAddress.postalCode
        if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
          return mindate
        }
        const preCode = pc.toString().substring(0, 2)
        const to = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
        if (to.length < 1) {
          return new Date()
        }
        const o = this.preAdd.Outlets.filter(a => a.OutletId === to[0].ReplacementOutletId)
        if (o.length > 0) {
          this.selectedOutletId = o[0].OutletId
          // const month = this.getPickupDateMonth()
          var hour = this.getFromDate(today, o[0])
          if (hour === null) {
            return null
          }
          const endTime = new Date((new Date(this.pickupDateFormat + ' ' + hour + ':00')).getTime() + (2 * 60 * 60 * 1000))
          const theMinDate = endTime.getTime() > mindate.getTime() ? endTime : mindate
          return theMinDate
        }
        return mindate
      },
      set: function () {
        if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
          return new Date()
        }
        const pc = this.deliverAddress.postalCode
        if (pc !== '' && !isNaN(parseInt(pc)) && parseInt(pc) > 10) {
          const preCode = pc.toString().substring(0, 2)
          const to = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
          if (to.length > 0) {
            const o = this.preAdd.Outlets.filter(a => a.OutletId === to[0].ReplacementOutletId)
            if (o.length > 0) {
              this.selectedOutletId = o[0].OutletId
            }
          }
        }
      }
    },
    deliveryMaxDate () {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date()
      }
      const pc = this.deliverAddress.postalCode
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return new Date()
      }
      const preCode = pc.toString().substring(0, 2)
      const o = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
      if (o.length > 0) {
        const today = this.getPickupDate()
        const month = this.getPickupDateMonth()
        var hour = this.getEndDate(today, o[0])
        if (hour === null) {
          return null
        }
        const endTime = today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':00'
        return new Date(endTime)
      }
      return new Date()
    },
    deliveryMaxDateReplace () {
      if (this.pickupDateFormat === null || this.pickupDateFormat === '') {
        return new Date()
      }
      const pc = this.deliverAddress.postalCode
      if (pc === '' || isNaN(parseInt(pc)) || parseInt(pc) < 10) {
        return new Date()
      }
      const preCode = pc.toString().substring(0, 2)
      const to = this.preAdd.Outlets.filter(a => a.DeliveryPostalZones.indexOf(preCode) >= 0)
      if (to.length < 1) {
        return new Date()
      }
      const o = this.preAdd.Outlets.filter(a => a.OutletId === to[0].ReplacementOutletId)
      if (o.length > 0) {
        const today = this.getPickupDate()
        const month = this.getPickupDateMonth()
        var hour = this.getEndDate(today, o[0])
        if (hour === null) {
          return null
        }
        const endTime = today.getFullYear() + '/' + month + '/' + today.getDate() + ' ' + hour + ':00'
        return new Date(endTime)
      }
      return new Date()
    },
    pickupDateFormat () {
      if (this.pickupDateDate === null) {
        return ''
      }
      return this.pickupDateDate.replace(/-/g, '/')
    }
  },
  destroy () {
    this.$store.dispatch('cart/noneFirstItem', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/checkout/PickupOrDelivery.vue